import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import DBStatus from '../components/DBStatus';

const { FiArrowRight, FiUser, FiGlobe } = FiIcons;

const Login = () => {
  const [username, setUsername] = useState('');
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) return;
    
    // Explicitly focus out to close mobile keyboard
    document.activeElement?.blur();
    
    const user = await login(username.trim());
    if (user) {
      if (user.role === 'super_admin') navigate('/admin');
      else if (user.role === 'master') navigate('/master');
      else if (user.role === 'pilot') navigate('/pilot');
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f5f7] flex items-center justify-center p-6 relative overflow-hidden">
      <motion.div 
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md relative z-10"
      >
        <div className="bento-card !p-8 md:!p-12 shadow-2xl text-center">
          <div className="mb-12">
            <div className="w-20 h-20 bg-black rounded-[2rem] flex items-center justify-center text-white text-4xl font-black mx-auto mb-8 shadow-xl">R</div>
            <h1 className="text-4xl font-black text-gray-900 tracking-tight">ROX Tracker</h1>
            <p className="text-gray-400 font-bold mt-2 text-sm">Boss Hunt Management OS</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-3">
              {/* FIXED: Centered the label */}
              <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block text-center">Username</label>
              <input 
                type="text" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                className="apple-input text-center" 
                placeholder="Enter Credentials"
                autoComplete="off"
                required
              />
            </div>

            {error && (
              <div className="p-4 bg-red-50 text-red-600 rounded-2xl text-xs font-bold border border-red-100">
                {error}
              </div>
            )}

            <div className="flex flex-col gap-4">
              <button 
                type="submit" 
                disabled={loading} 
                className="apple-button-primary w-full !py-5 text-lg"
              >
                {loading ? <div className="w-6 h-6 border-4 border-white/30 border-t-white rounded-full animate-spin" /> : 'Log In'}
              </button>
              
              {/* FIXED: Icon is now tight with the label */}
              <Link 
                to="/feeds" 
                className="apple-button-secondary w-full !py-4 text-sm flex items-center justify-center gap-2"
              >
                <FiGlobe className="text-lg" /> 
                <span>Public Activity Feed</span>
              </Link>
            </div>
          </form>
        </div>
      </motion.div>
      <DBStatus />
    </div>
  );
};

export default Login;